var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{style:({ 'background-image': 'url(' + _vm.background + ')' }),attrs:{"id":"banner"}},[_c('h1',[_vm._v(_vm._s(_vm.$t('bailes.banner.titulo')))]),_c('p',[_vm._v(_vm._s(_vm.$t('bailes.banner.descricao')))])])}
var staticRenderFns = []

export { render, staticRenderFns }